import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ToastContext = createContext(null);

let toastId = 0;
let listeners = [];
let toasts = [];

function emit() {
  listeners.forEach((listener) => listener(toasts));
}

function createToast(toast) {
  const id = `${Date.now()}-${toastId += 1}`;
  const item = {
    id,
    title: '',
    description: '',
    variant: 'default',
    ...toast,
  };

  toasts = [item, ...toasts].slice(0, 5);
  emit();

  const dismiss = () => {
    toasts = toasts.filter((current) => current.id !== id);
    emit();
  };

  window.setTimeout(dismiss, 3500);

  return { id, dismiss };
}

export function useToast() {
  const [stateToasts, setStateToasts] = useState(toasts);

  useEffect(() => {
    const listener = (nextToasts) => setStateToasts(nextToasts);
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((current) => current !== listener);
    };
  }, []);

  const dismiss = (id) => {
    toasts = toasts.filter((toast) => toast.id !== id);
    emit();
  };

  return useMemo(
    () => ({
      toast: createToast,
      toasts: stateToasts,
      dismiss,
    }),
    [stateToasts]
  );
}

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed right-4 top-4 z-[100] flex w-full max-w-sm flex-col gap-3 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto rounded-xl border p-4 shadow-lg backdrop-blur ${
            toast.variant === 'destructive'
              ? 'border-red-200 bg-red-50 text-red-950'
              : 'border-gray-200 bg-white text-gray-900'
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              {toast.title ? <div className="text-sm font-semibold">{toast.title}</div> : null}
              {toast.description ? (
                <div className="mt-1 text-sm text-gray-600">{toast.description}</div>
              ) : null}
            </div>
            <button
              type="button"
              className="text-xs font-medium text-gray-500 hover:text-gray-900"
              onClick={() => dismiss(toast.id)}
            >
              Close
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}